import type { Card } from '../../types';

export const HEX_WEAKEN: Card = {
  id: 'hex-weaken',
  name: 'Hex',
  type: 'support',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'weaken', magnitude: 2, duration: 2, target: 'opponent' },
    },
  ],
};
